var recommendX = [0,0,0];
var aim = "left";
var productTimer;
var product = {
	current: 0,
	pageMax: 0,
	count: 6,
	countMax: 1,
	clickTop: 0,
	clickIndex: 0,
	filter: [],
	chart: "",
	scrollTop: 0,
	init: function(){
		//-console.log("product init")
		var url = "/api/product.php";
		var param = {
			page: product.current
		};
		
		product.current = 0;
		load.getJson(url, param).done(function(json){
			product.countMax 	= json.total;
			product.count 		= json.count;
			product.pageMax 	= Math.ceil( product.countMax/product.count );
			//console.log(product.count, product.countMax)
			product.makeHTML(json);
		});
	},
	loadNext: function(){
		product.current++;
		if(product.current >= product.pageMax){
			product.current = product.pageMax - 1;
			return false
		}
		common.startLoading();
		var param = "";
		if(product.filter.length > 0){
			for(var i = 0; i < product.filter.length; i++){
				if(i < product.filter.length-1){
					param += "cat[]=" + product.filter[i] + "&";
				}else{
					param += "cat[]=" + product.filter[i];
				}
			}
			var url = "/api/product.php?" + param;
		}else{
			var url = "/api/product.php";
		}
		var params = {
			page: product.current
		}
		
		load.getJson(url, params).done(function(json){
			product.makeHTML(json);
		});
	},
	getFilterPost: function(param){
		$("#list_products").addClass("change");
		if(product.filter.length > 0){
			var url = "/api/product.php?" + param;
		}else{
			var url = "/api/product.php";
		}
		
		load.getJson(url, param).done(function(json){
			product.countMax 	= json.total;
			product.count 		= json.count;
			product.pageMax 	= Math.ceil( product.countMax/product.count );
			product.current 	= 0;
			setTimeout(function(){
				common.scrollToPosition(0);
				$("#list_products li").remove();
				product.makeHTML(json);
			},600);
		});
	},
	makeHTML: function(json){
		let start 	= product.current*product.count;
		let end 	= start + product.count;
		//console.log(json.products);
		let jsonShuffled = shuffleObj(json.products);
		//console.log(jsonShuffled);
		if(product.current === product.pageMax-1){
			end = product.countMax;
		}
		var data = jsonShuffled;
		//console.log(json, data)
		//console.log(data)
		var HTML = '';
		var $count = 0;
		var imgArry = [];
		for(let i = start; i < end; i++){
			let d = data[$count];
			let isNew = false;
			let cls = "";
			if(d.is_new){
				cls = "new";
			}else if(d.is_renew){
				cls = "renew";
			}else if(d.is_archive){
				cls = "archived";
			}
			HTML 	+= '<li class="' + cls + '"><a href="' + d.url + '" title="' + d.title + '">'
					+ '<div class="img">'
					+ '<figure><img src="' + d.image2 + '" sizes="50vw" srcset="' + d.image1 + ' 320w, ' + d.image2 + ' 640w" alt="' + d.title + '"></figure>'
					+ '<div class="name"><div class="name_inner"><div class="ttl_h3_name"><h3>' + d.title + '</h3></div></div></div>'
					+ '</div></a></li>';
			imgArry.push(d.image2);
			$count++;
		}
		$("#list_products ul").append(HTML);
		preload.startLoad(imgArry.length,imgArry, true).done(function(){
			$("body").removeClass("loading_content");
			if(	$("#list_products").hasClass("change") ){
				$("#list_products").removeClass("change");
			}
			common.endLoading();
			product.nav();
		});
	},
	nav: function(){
		$("#list_products li a").off().on("click", function(e){
			e.preventDefault();
			product.clickTop = $(this).offset().top - $(document).scrollTop();
			product.clickIndex = $("#list_products li a").index(this);
			
			//左右どちらにやるか
			if(product.clickIndex%2 === 1){
				$("#detail_product").addClass("r");
			}else{
				$("#detail_product").removeClass("r");
			}
			let url = $(this).attr("href");
			page.changeURL(url);
			product.scrollTop = $(document).scrollTop();
		});
		$("#recommend_product li a").off().on("click", function(e){
			e.preventDefault();
			if(!$(".list_recommend").hasClass("drag")){
				let url = $(this).attr("href");
				page.changeURL(url);
			}
		});
		common.mouseCursor();
		if(!isSmallScreen){
			smoothScroll.init();
		}
		$("a#btn_show_detail").off().on("click", function(){
			$(this).remove();
			$(".col_r .block_txt").animate({
				height: "toggle", opacity: "toggle"
			},200);
		});
		$('#filter input[type="checkbox"]').off().on("change", function(){
			let val = $(this).val();
			$(this).toggleClass("active");
			product.filter = [];
			$('#filter input[type="checkbox"]').each(function(){
				let $this = $(this);
				if( $this.hasClass("active") ){
					let val = $this.val();
					product.filter.push(val);
				}
			});
		});
		$("#btn_apply").off().on("click", function(){
			let param = "";
			for(var i = 0; i < product.filter.length; i++){
				if(i < product.filter.length-1){
					param += "cat[]=" + product.filter[i] + "&";
				}else{
					param += "cat[]=" + product.filter[i];
				}
			}
			$html.classList.remove("show_filter");
			product.getFilterPost(param);
		});
		product.resize();
		setTimeout(function(){
			common.resize();
		},600);
		$(window).off("popstate").on("popstate", function(){
			page.checkURL();
		});
		setTimeout(function(){
			product.resize();
		},600);
	},
	resize: function(){
		animations = [];
		if($html.classList.contains("show_product")){
			$("#detail_product .a").each(function(i){
				let _a = object(Animate);
				_a.top 	= Math.floor( $(this).position().top );
				_a.show = Math.floor( _a.top + window.innerHeight/3 );
				animations.push(_a);
			});
			recommendBlocks = [];
			$("#recommend li").each(function(i){
				let _r = object(Recommend);
				_r.start = $(this).offset().left;
				_r.end 	= _r.start + $(this).width();
				_r.href = $(this).find("a").attr("href");
				recommendBlocks.push(_r);
			});
			//console.log(recommendBlocks)
		}
	},
	loadPage: function(url){
		if($html.classList.contains("show_product")){
			$("#detail_product").addClass("disable");
			$("#detail_product").addClass("change_detail");
			setTimeout(function(){
				common.scrollToPosition(0,10);
				smoothScroll.currentPos = 0;
				smoothScroll.movingPos = 0;
				smoothScroll.endPoint = 0;
				loadAndAdd();
			}, 600);
		}else{
			loadAndAdd();
		}
		function loadAndAdd(){
			//console.log("product page:",url);
			$.get(url, {},function(data){
				var out_html 	= $(data),
					postTitle 	= $("header", out_html)[0];
				product.changeContent(out_html).done(function(){
					product.showPage();
				});
			});
		}
	},
	changeContent: function(data){
		var defer = $.Deferred();
		var out_html 	= $(data),
			ttl 		= out_html.filter("title")[0].innerHTML,
			$content 	= $("#detail_product #detail_product_content"),
			content 	= $("#load_content", out_html)[0],
			postTitle 	= $("header", out_html)[0];
		$content.html(content);

		var links = out_html.filter("link");
		common.getLangURL(links);
		document.title = ttl;
		setTimeout(function(){
			let srcset = $(".img_product figure img").attr("srcset");
			srcset = srcset.replace(" 320w", "");
			srcset = srcset.replace(" 640w", "");
			let arry = srcset.split(",");
			let imgArry = [];
			if(isSmallScreen){
				imgArry.push(arry[0]);
			}else{
				imgArry.push(arry[1]);
			}
			product.makeChart();
			preload.startLoad(imgArry.length,imgArry, false).done(function(){
				defer.resolve();
			});
		},100);
		return defer.promise();
	},
	showPage: function(){
		if($html.classList.contains("show_product")){
			setTimeout(function(){
				$("#detail_product").removeClass("disable");
				setTimeout(function(){
					$("#detail_product").removeClass("change_detail");
					product.nav();
				},600);
			},400);
		}else{
			$html.classList.add("product");
			let _t = product.clickTop - $("#detail_product_content").position().top;
			$("#detail_product").css({
				"transform": "translate3d(0, " + _t + "px,0)"
			});
			setTimeout(function(){
				product.showDetail();
			}, 50);
		}
	},
	showDetail: function(){
		$html.classList.add("set_product");
		$("#list_products li").eq(product.clickIndex).addClass("disable");

		setTimeout(function(){
			common.scrollToPosition(0,10);
			$html.classList.add("show_product");
			$("#detail_product").css({
				"transform": "translate3d(0, 0px,0)"
			});
			setTimeout(function(){
				$html.classList.add("active_product");
				product.nav();
			}, 600);
		}, 600);
	},
	closeDetail: function(){
		$("#list_products li").eq(product.clickIndex).removeClass("disable");
		$("#detail_product").addClass("disable");

		setTimeout(function(){
			$html.classList.remove("show_product");
			$html.classList.remove("set_product");
			$("#detail_product").css({
				"transform": ""
			});
			//モーダル内、トップに戻す
		//	common.scrollToPosition(product.scrollTop);
			window.scrollTo(0, product.scrollTop);
			//console.log(isLang)
			if(isLang === "ja"){
				$(".lang_en a").attr("href", "/en/");
			}else if(isLang === "en"){
				$(".lang_ja a").attr("href", "/");
			}
			setTimeout(function(){
				$(".btn_lang").removeClass("disable");
				$html.classList.remove("product");
				$html.classList.remove("active_product");
				$("#detail_product").removeClass("disable");
			},400);
		},600);
	},
	makeChart: function(){
		let r = 120;
		let deg = 72;
		let polygon = "",
			result = "",
			resultTo = "",
			line 	= "";
		for(var i = 0; i < 5; i++){
			let angle = Math.PI/180*(deg*i + 270);
			let x = Math.floor(r*Math.cos(angle) ) + r;
			let y = Math.floor( r*Math.sin(angle) ) + r;
			let n = parseInt( $(".chart p").eq(i).attr("data-param") );
			let xx = r;
			let yy = r;
			let xxx = Math.floor( (r/5*n)*Math.cos(angle) ) + r;
			let yyy = Math.floor( (r/5*n)*Math.sin(angle) ) + r;
			polygon += x + "," + y + " ";
			$(".chart line#line" + i).attr({
				"x1": r,
				"x2": x,
				"y1": r,
				"y2": y
			});
			result 		+= xx + "," + yy + " ";
			resultTo	+= xxx + "," + yyy + " ";
		}
		$(".chart svg polygon#svg_wrap").attr("points", polygon);
		$(".chart svg polygon#svg_result").attr("points", resultTo);
		//$(".chart #showChart").attr("from", result);
		//$(".chart #showChart").attr("to", resultTo);
		$("iframe").each(function(){
			$(this).wrap('<div class="movie"></div>');
		});
	}
}
